module.exports = __webpack_public_path__ + "static/media/vactooine.53ca63ec.jpg";